import { render } from "./Users.html?vue&type=template&id=284a8a52&ts=true"
import script from "./Users.ts?vue&type=script&lang=ts"
export * from "./Users.ts?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__